<template>
  <div class="consulting-detail">
    <div class="detail-header">
      <div class="header-title">{{ detailData.nickName }} 的咨询室</div>
      <div class="header-button">
        <el-button
          v-if="detailData.status === 0 && (detailData.authType === 1 || detailData.authType === 4 || $store.state.UserInfo.isManage === true)"
          type="primary"
          @click="handleAccept"
          >接受预约</el-button
        >
        <el-button
          v-if="detailData.status === 0 && (detailData.authType === 1 || detailData.authType === 4 || $store.state.UserInfo.isManage === true)"
          type="danger"
          plain
          @click="handleRefuse"
          >拒绝预约</el-button
        >
        <el-button v-if="detailData.status === 2 && detailData.authType === 2" type="primary" @click="handleAddTimes"
          >延长时间</el-button
        >
        <el-button v-if="detailData.status === 1 && detailData.authType !== 3" type="primary" @click="handleChangeTime">修改时间</el-button>
        <el-button v-if="
          (detailData.status === 0 && (detailData.authType === 2 || detailData.authType === 4 || $store.state.UserInfo.isManage === true)) ||
          (detailData.status === 1 && (detailData.authType === 1 || detailData.authType === 2 || detailData.authType === 4 || $store.state.UserInfo.isManage === true))
         " type="primary"  @click="handleCancel">取消预约</el-button>
        <el-button v-if="detailData.status === 3 && detailData.authType === 2" type="primary" @click="handleRefund">退款</el-button>
        <el-button v-if="detailData.status === 3 && $store.state.UserInfo.isManage === true" type="primary" @click="handleVideoRecords">回看</el-button>
        <el-button v-if="detailData.status === 2 && $store.state.UserInfo.isManage === true && detailData.isShutByManager !== 1" type="danger" @click="handleClose">关闭</el-button>
      </div>
    </div>
    <div class="detail-container">
      <el-form v-model="detailData" label-position="left" label-width="115px">
        <el-form-item label="被约人">
          <div class="user-info-container">
            <div class="user-avatar">
              <el-image
                :class="['user-gender', detailData.gender === 0 ? 'gender-0' : 'gender-1']"
                :src="
                  detailData.gender === 0
                    ? gender0
                    : gender1
                "
              />
              <el-avatar
                style="border: 2px solid #ACACAC;"
                icon="el-icon-user-solid"
                :src="detailData.headPicUrl"
                :size="107"
              />
              <el-button
                v-if="detailData.followedFlag === 0 && detailData.consultantUserId !== $store.state.UserInfo.id"
                type="primary"
                class="follow-btn"
                @click="handleFollow(1)"
              >
                <el-image
                  :src="require('../../../assets/consultingRoom/gz.png')"
                  style="width: 16px;height: 16px;"
                />关注
              </el-button>
              <el-button v-if="detailData.followedFlag === 1 && detailData.consultantUserId !== $store.state.UserInfo.id" type="primary" class="follow-btn" @click="handleFollow(0)">取消关注</el-button>
            </div>
            <div class="user-info">
              <div class="name-row">
                <div class="nick-name">
                  {{ detailData.nickName }}
                </div>
                <div class="user-tag">
                  <div
                    class="user-tag-item"
                    v-for="(tag, tagIndex) in detailData.workedFamousCompanyList"
                    :key="tagIndex"
                  >
                    {{ tag }}
                  </div>
                </div>
                <div class="work-info">{{ detailData.occupationName }} · {{ detailData.workYears }}年</div>
              </div>
              <div class="position-row">
                <span class="el-icon-location-outline">北京</span>
              </div>
              <div class="btn-row">
                <el-button type="primary" plain @click="handleDetail">详情</el-button>
                <el-button type="primary" plain @click="handlePersonalPage">个人页</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-divider style="background-color: #E6E6E6;gap: 122px;"></el-divider>
        <div class="consulting-container">
          <div class="container-left">
            <el-form-item label="预约人">
              <div style="display: flex;align-items: center;">
                <span>{{ detailData.consulterName }}</span>
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">
                    {{detailData.refundInfo}}
                  </div>
                  <el-image :src="require('@/assets/consultingRoom/tip_refund_info.png')" v-if="detailData.refundInfo" style="width: 24px;height: 24px;margin-left: 5px;"/>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="预约时间">
              {{ detailData.appointmentTime }} {{ detailData.dayOfWeek }} {{ formatConsultDuration(detailData.consultDuration) }}
            </el-form-item>
            <el-form-item label="预约金额">
              <span style="color:#FF724C">
                ¥{{ detailData.consultAmount }} · {{ detailData.consultPeopleCount }}人
              </span>
            </el-form-item>
            <el-form-item label="实际消耗">
              <div style="display: flex;align-items: center;">
                <span style="color:#FF724C">
                  ¥{{ detailData.actualConsumeAmount }} · {{ detailData.actualConsumeDuration }}分钟
                </span>
                <el-tooltip popper-class="popper-width" effect="dark" placement="top">
                  <div slot="content">
                    主要按双方实际沟通时长计费，您可提前结束沟通，之后未使用的时长不计费。具体计费规则参见：<span @click="handleQuestion" style="line-height: 20px;text-decoration: underline;cursor: pointer;">常见问题页</span>
                  </div>
                  <el-image :src="require('@/assets/consultingRoom/tip_question_mark_default.png')" style="width: 24px;height: 24px;margin-left: 5px;"/>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="已退金额" v-if="detailData.alreadyRefundAmount"> {{ detailData.alreadyRefundAmount }} </el-form-item>
            <el-form-item label="可退金额" v-if="detailData.canRefundAmount">
<!--            <el-form-item label="可退金额" >-->
              <div style="display: flex;align-items: center;">
                <span>{{ detailData.canRefundAmount || '0' }}</span>
                <el-tooltip popper-class="popper-width" effect="dark" content="站外类订单，这里只会记录可退款金额的数据，具体退款需要您去站外下单的平台申请，且申请退款金额不可超过此处可退金额。（另外如果除了未消耗自动退的类型外，还需要其它退款（比如不满意退之类），可以去站内此预约的订单上点退款后，这里就会更新可退金额。）" placement="top">
                  <el-image :src="require('@/assets/consultingRoom/tip_question_mark_error.png')" style="width: 24px;height: 24px;margin-left: 5px;"/>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="咨询类型">
              {{ $dict.getDictLabel('consult_type', detailData.consultType) }}
            </el-form-item>
            <el-form-item label="问题描述" v-if="detailData.consultDescription">
              {{ detailData.consultDescription || '-' }}
            </el-form-item>
            <el-form-item label="状态">
              <el-tag type="primary" plain style="border-radius: 57px;font-size: 18px;">
                {{ $dict.getDictLabel('status', detailData.status) }}
              </el-tag>
            </el-form-item>
            <el-form-item label="原因" v-if="detailData.reason">
              {{ detailData.reason || '-' }}
            </el-form-item>
          </div>
          <div class="container-right">
            <el-form-item label="预约单号">
              {{ detailData.appointmentId }}
            </el-form-item>
            <el-form-item label="下单时间">
              {{ detailData.createOrderTime }}
            </el-form-item>
            <el-form-item label="退款期限">
              {{ detailData.refundLimitTime }}
            </el-form-item>
            <el-form-item label="行为记录">
              <el-button type="primary" plain @click="handleOpenHistoryDialog">
                查看
              </el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="more-row">
        <el-dropdown placement="top-end" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <el-image :src="require('../../../assets/consultingRoom/more.png')" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="more-btn" command="report">
              <el-image :src="require('../../../assets/consultingRoom/tip_error.png')" />
              <span class="report">举报</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!--  举报-dialog  -->
    <el-dialog :visible="reportDialogVisible" title="举报" width="500px" @close="closeReportDialog" destroy-on-close>
      <el-form ref="refReportForm" :model="reportFormData" :rules="reportFormRules" inline label-width="150px">
        <el-form-item label="举报">
          {{ reportFormData.reportUserName }}
        </el-form-item>
        <el-form-item label="预约单号">
          {{ reportFormData.appointmentId }}
        </el-form-item>
        <el-form-item label="类型" type="type">
          <el-select v-model="reportFormData.type" placeholder="请选择类型" clearable>
            <el-option
              v-for="dict in getDict('report_type')"
              :key="dict.value"
              :label="dict.label"
              :value="dict.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="reportFormData.description"
            placeholder="请输入描述（可不填）"
            type="textarea"
            :rows="5"
            maxlength="300"
            resize="none"
            clearable
          />
        </el-form-item>
        <div style="text-align: center">
          <el-button type="primary" @click="handleConfirmReport">举报</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--  拒绝预约-dialog  -->
    <el-dialog
      :visible="refuseDialogVisible"
      title="拒绝预约"
      width="500px"
      @close="closeRefuseDialog"
      destroy-on-close
    >
      <div style="display: flex;justify-content: center;">
        <el-button type="danger" @click="handleConfirmRefuse">拒绝预约</el-button>
      </div>
      <el-form>
        <el-form-item label="拒绝原因（可不填）">
          <el-input
            v-model="refuseFormData.reason"
            placeholder="请输入拒绝原因（可不填）"
            type="textarea"
            :rows="5"
            maxlength="200"
            resize="none"
            clearable
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--  延长时间-dialog  -->
    <el-dialog
      :visible="addTimeDialogVisible"
      title="延长时间"
      width="500px"
      @close="closeAddTimeDialog"
      destroy-on-close
    >
      <el-form ref="refAddTimeForm" :model="addTimeFormData" :rules="addTimeFormRules" inline>
        <div v-if="timeOptions.length === 0" style="display: flex;justify-content: center;">
          因承约人有新的预约即将开始，本预约暂无法延长
        </div>
        <div v-else style="display: grid;justify-content: center;">
          <el-form-item label="延长至" prop="time">
            <el-select v-model="addTimeFormData.time" placeholder="请选择延长至">
              <el-option v-for="time in timeOptions" :key="time.value" :label="time.key" :value="time.value" />
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="handleConfirmAddTime">延长</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--  修改时间-dialog  -->
    <el-dialog
      :visible="changeTimeDialogVisible"
      title="修改时间"
      width="500px"
      @close="closeChangeTimeDialog"
      destroy-on-close
    >
      <el-form
        ref="refChangeTimeForm"
        :model="changeTimeFormData"
        :rules="changeTimeFormRules"
        inline
        label-width="100px"
      >
        <div style="display: grid;justify-content: center;">
          <div style="display: flex;">
            <el-form-item label="开始时间" prop="date">
              <el-date-picker
                v-model="changeTimeFormData.date"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="{disabledDate: disabledDate}"
                @change="handleDateChange"
              />
            </el-form-item>
            <el-form-item prop="time">
              <el-select v-model="changeTimeFormData.time" placeholder="选择时间" style="width: 105px; margin-left: 4%">
                <el-option v-for="(time, index) in changeTimeOptions" :key="index" :label="time" :value="time" />
              </el-select>
            </el-form-item>
          </div>
          <el-form-item v-if="$store.state.UserInfo.isManage === true" label="发起方" prop="initiatorType">
            <el-select v-model="changeTimeFormData.initiatorType" clearable placeholder="请选择发起方">
              <el-option
                v-for="dict in getDict('initiator_type')"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="handleConfirmChangeTime">请求修改</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--  取消预约-dialog  -->
    <el-dialog
      :visible="cancelDialogVisible"
      title="取消预约"
      width="500px"
      @close="closeCancelDialog"
      destroy-on-close
    >
      <el-form ref="refCancelForm" :model="cancelFormData" inline label-width="80x">
        <div style="display: grid;justify-content: center;">
          <el-button type="danger" style="margin-bottom: 22px;" @click="handleConfirmCancel">取消预约</el-button>
          <el-form-item v-if="$store.state.UserInfo.isManage === true" label="发起方" prop="initiatorType" label-width="68px">
            <el-select v-model="cancelFormData.initiatorType" clearable placeholder="请选择发起方" style="width: 217px;">
              <el-option
                v-for="dict in getDict('initiator_type')"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="取消原因（可不填）">
            <template slot="label">
              <div>取消原因</div>
              <div>(可不填)</div>
            </template>
            <el-input
              v-model="cancelFormData.reason"
              placeholder="请输入取消原因（可不填）"
              type="textarea"
              :rows="5"
              maxlength="200"
              resize="none"
              clearable
            />
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!--  关闭咨询室-dialog  -->
    <el-dialog :visible="closeDialogVisible" title="关闭咨询室" width="500px" @close="closeRoomDialog" destroy-on-close>
      <el-form
        ref="refCloseForm"
        :model="closeFormData"
        :rules="closeFormRules"
        label-position="top"
        label-width="150px"
      >
        <div style="display: grid;justify-content: center;">
          <el-form-item label="关闭原因" prop="reason">
            <el-input
              v-model="closeFormData.reason"
              placeholder="请输入关闭原因"
              type="textarea"
              :rows="5"
              maxlength="100"
              resize="none"
              clearable
            />
          </el-form-item>
          <el-button type="danger" style="margin-bottom: 22px;" @click="handleConfirmClose">确认关闭咨询室</el-button>
          <div>
            (关闭后，将强行中止双方的咨询连线）
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!--  行为记录-dialog  -->
    <el-dialog
      :visible="historyDialogVisible"
      title=""
      width="677px"
      @close="closeHistoryDialog"
      destroy-on-close
      custom-class="history-dialog"
    >
      <HistoryTimeLine v-if="historyDialogTableData.length !== 0" v-model="historyDialogTableData"/>
<!--      <el-table :data="historyDialogTableData" height="500px">-->
<!--        <el-table-column label="创建时间" prop="createTime" width="180px" />-->
<!--        <el-table-column label="记录内容" prop="content" />-->
<!--      </el-table>-->
    </el-dialog>
    <!--  回看录像-dialog  -->
    <el-dialog
      :visible="recordDialogVisible"
      title="选择回看文件"
      width="450px"
      @close="closeRecordDialog"
      destroy-on-close
      align="center"
      custom-class="history-dialog"
    >
      <div style="display: flex;justify-content: center;">
        <div class="record-video">
          <div
            class="record-video-btn"
            v-for="(video, videoIndex) in recordData"
            :key="videoIndex"
            @click="handleOpenRecordVideo(video)"
          >
            <div>
              {{ videoIndex + 1 }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addTimes,
  changeTime, changeTimePropose,
  consultMeetingAccept,
  consultMeetingCancel,
  consultMeetingClose,
  consultMeetingRefuse,
  getAvailableTimes,
  queryBehaviorRecords,
  reportCreate,
  videoRecords
} from '@/api/consultingRoom'
import {getDict} from '@/utils/dict'
import moment from 'moment'
import {cancelFollow, toggleFollow} from '@/api/consultingService'
import {isWorkday} from 'chinese-days' // 第三方节假日判断库
import HistoryTimeLine from '@/views/consultingRoom/components/HistoryTimeLine.vue'
export default {
  components: {HistoryTimeLine},
  props: {
    // 详情数据
    detailData: {
      type: Object,
      default: () => {}
    }
  },
  // watch:{
  //   detailData: {
  //     handler(value) {
  //       console.log('detailData   value = ', value)
  //     }
  //   }
  // },
  data() {
    return {
      gender0: require('../../../assets/consultingRoom/gender_0.png'),
      gender1: require('../../../assets/consultingRoom/gender_1.png'),
      // 举报-dialog-显示状态
      reportDialogVisible: false,
      // 举报-dialog-表单数据
      reportFormData: {},
      // 举报-dialog-表单校验规则
      reportFormRules: {},
      // 拒绝预约-dialog-显示状态
      refuseDialogVisible: false,
      // 拒绝预约-表单数据
      refuseFormData: {},
      // 延长时间-dialog-显示状态
      addTimeDialogVisible: false,
      // 延长时间-dialog-下拉框数据
      timeOptions: [],
      // 延长时间-dialog-表单数据
      addTimeFormData: {},
      // 延长时间-dialog-表单校验规则
      addTimeFormRules: {
        time: [{required: true, message: '请选择延长时间', trigger: 'blur'}]
      },
      // 修改时间-dialog-显示状态
      changeTimeDialogVisible: false,
      // 修改时间-dialog-类型，propose-从修改预约记录的列表的 建议新时间打开
      changeTimeType: '',
      // 修改时间-dialog-表单数据
      changeTimeFormData: {},
      // 修改时间-时间下拉框数据
      changeTimeOptions:[],
      conflictTip: '',
      // 修改时间-dialog-表单校验规则
      changeTimeFormRules: {
        date: [{required: true, message: '请选择开始日期', trigger: 'blur'}],
        time: [{required: true, message: '请选择开始时间', trigger: 'blur'}],
        initiatorType: [{required: true, message: '请选择发起方', trigger: 'blur'}]
      },
      // 取消预约-dialog-显示状态
      cancelDialogVisible: false,
      // 取消预约-dialog-表单数据
      cancelFormData: {},
      // 关闭咨询室-dialog-显示状态
      closeDialogVisible: false,
      // 关闭咨询室-dialog-表单数据
      closeFormData: {},
      // 关闭咨询室-dialog-表单校验规则
      closeFormRules: {
        reason: [{required: true, message: '请输入关闭原因', trigger: 'blur'}]
      },
      // 行为记录-dialog-显示状态
      historyDialogVisible: false,
      // 行为记录-dialog-列表数据
      historyDialogTableData: [],
      // 回看录像-dialog-显示状态
      recordDialogVisible: false,
      // 回看录像-dialog-录像数据
      recordData: []
    }
  },
  mounted() {
    console.log('详情页面 - - - ', this.detailData)
  },
  methods: {
    getDict,
    // 格式化分钟转小时
    formatConsultDuration(minutes) {
      const duration = moment.duration(minutes, 'minutes');
      const hours = Math.floor(duration.asHours());
      const mins = duration.minutes();
      let result = '';
      if (hours > 0) {
        result += `${hours}小时`;
      }
      if (mins > 0) {
        result += `${mins}分钟`;
      }
      return result || '0分钟';
    },
    // 常见问题
    handleQuestion() {
      const routeData = this.$router.resolve({
        path: '/faq?tag=咨询'
      })
      window.open(routeData.href, '_blank')
    },
    handleCommand(command) {
      switch (command) {
        case 'report':
          this.handleReport()
          break
        default:
          break
      }
    },
    // 举报
    handleReport() {
      const {appointmentId, nickName, consulterName, authType} = this.detailData
      this.reportFormData.reportUserName = authType === 1 ? consulterName : nickName
      this.reportFormData.appointmentId = appointmentId
      this.reportFormData.position = '咨询-咨询室'
      this.reportFormData.positionUrl = '/consultingRoom'
      this.reportFormData.businessInfo = '预约单号:' + appointmentId
      this.reportDialogVisible = true
    },
    // 举报-dialog-关闭事件
    closeReportDialog() {
      this.reportDialogVisible = false
      this.reportFormData = {}
    },
    // 举报-dialog-确认举报
    handleConfirmReport() {
      this.$refs.refReportForm.validate(valid => {
        if (valid) {
          console.log('this.reportFormData = ', this.reportFormData)
          reportCreate(this.reportFormData).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功')
              this.closeReportDialog()
            }
          })
        }
      })
    },
    handleDetail() {
      // const routeData = this.$router.resolve({
      //   path: '/personalConsultDetail',
      //   query: {consultant_id: this.detailData.consultantId}
      // })
      // window.open(routeData.href, '_blank')
      this.$router.push({
        path: '/personalConsultDetail',
        query: {consultant_id: this.detailData.consultantId}
      })
    },
    handlePersonalPage() {
      // const routeData = this.$router.resolve({
      //   path: '/personal/detail/'+this.detailData.employeeId,
      // })
      // window.open(routeData.href, '_blank')
      this.$router.push({
        path: '/personal/detail/'+this.detailData.employeeId,
      })
    },
    // 关注/取消关注
    handleFollow(followedFlag) {
      if (followedFlag === 0) {
        // 取消关注
        cancelFollow({objectId: this.detailData.employeeId, objectType: '咨询'})
          .then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功')
              this.$set(this.detailData, 'followedFlag', 0)
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      } else {
        // 关注
        toggleFollow({objectId: this.detailData.employeeId, objectType: '咨询'})
          .then(res => {
            if (res.code === 200) {
              this.$message.success('关注成功')
              this.$set(this.detailData, 'followedFlag', 1)
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      }
    },
    // 接受预约
    handleAccept() {
      this.$confirm('确认接受预约吗？').then(() => {
        consultMeetingAccept({appointmentId: this.detailData.appointmentId}).then(res => {
          if (res.code === 200) {
            this.$message('操作成功')
            this.$emit('callGetDetail')
          }
        })
      })
    },
    // 拒绝预约
    handleRefuse() {
      this.refuseDialogVisible = true
    },
    // 拒绝预约-dialog-关闭事件
    closeRefuseDialog() {
      this.refuseDialogVisible = false
      this.refuseFormData.reason = ''
    },
    // 拒绝预约-dialog-确认拒绝
    handleConfirmRefuse() {
      if (this.detailData.status !== 0) {
        this.$message.warning('预约单状态不正确')
        return
      }
      const amount = Number((Number(this.detailData.consultAmount) / Number(this.detailData.consultDuration)).toFixed(2))
      this.$confirm('拒绝预约，将会生成一笔1分钟量（' + amount + '元）的负收入到您账户。确认拒绝吗？').then(() => {
        this.refuseFormData.appointmentId = this.detailData.appointmentId
        consultMeetingRefuse(this.refuseFormData).then(res => {
          if (res.code === 200) {
            this.$message('操作成功')
            this.refuseDialogVisible = false
            this.$emit('callGetDetail')

          }
        })
      })
    },
    // 延长时间
    handleAddTimes() {
      this.addTimeDialogVisible = true
      getAvailableTimes(this.detailData.appointmentId).then(res => {
        if (res.code == 200) {
          this.timeOptions = res.data
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 延长时间-dialog-关闭事件
    closeAddTimeDialog() {
      this.addTimeDialogVisible = false
      this.addTimeFormData = {}
    },
    // 延长时间-dialog-确认延时
    handleConfirmAddTime() {
      this.$refs.refAddTimeForm.validate(valid => {
        if (valid) {
          this.addTimeFormData.appointmentId = this.detailData.appointmentId
          addTimes(this.addTimeFormData).then(res => {
            if (res.code === 200) {
              this.$dialog.toast('操作成功')
              this.addTimeDialogVisible = false
              this.addTimeFormData = {}
              this.$router.push({
                path: '/pay',
                query: {
                  orderId: res.data
                }
              })
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    disabledDate(time) {
      // 只能选择今天及以后的日期
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return time.getTime() < today.getTime()
    },
    /**
     * 日期变更（生成对应时间选项+判断工作日）
     */
    handleDateChange(date) {
      this.$set(this.changeTimeFormData,'time', '')
      this.conflictTip = ''
      if (!date) return
      // 判断是否为工作日
      const isWork = isWorkday(date)
      // 生成时间选项
      this.generateTimeOptions(isWork)
    },
    /**
     * 生成时间选项（工作日19:00-23:00，节假日9:00-23:00）
     */
    generateTimeOptions(isWork) {
      const timeOptions = []
      // 起始时间：工作日19:00，节假日9:00
      const startHour = isWork ? 19 : 9

      // 生成半小时间隔的时间选项
      for (let hour = startHour; hour < 23; hour++) {
        const formattedHour = hour.toString().padStart(2, '0')
        timeOptions.push(`${formattedHour}:00`)
        timeOptions.push(`${formattedHour}:30`)
      }
      // 补充23:00选项
      timeOptions.push('23:00')
      this.changeTimeOptions = timeOptions
    },
    // 修改时间
    handleChangeTime(type,row) {
      this.changeTimeDialogVisible = true
      this.changeTimeType = type
      if(type === 'propose') {
        this.changeTimeFormData = {
          id: row.id,
          initiatorType: this.$store.state.UserInfo.id === this.detailData.consultantUserId ? 1 : 2
        }
      }
    },
    // 修改时间-dialog-关闭事件
    closeChangeTimeDialog() {
      this.changeTimeDialogVisible = false
      this.changeTimeFormData = {}
      this.changeTimeOptions = []
    },
    // 修改时间-dialog-确认修改
    handleConfirmChangeTime() {
      this.$refs.refChangeTimeForm.validate(valid => {
        if (valid) {
          this.changeTimeFormData.appointmentId = this.detailData.appointmentId
          this.changeTimeFormData.startTime = this.changeTimeFormData.date + ' ' + this.changeTimeFormData.time + ':00'
          this.$confirm('确定请求修改吗？').then(()=>{
            if(this.changeTimeType === 'propose') { // 从 修改预约记录列表-建议新时间 进入
              changeTimePropose(this.changeTimeFormData).then(res=>{
                if(res.code === 200) {
                  this.$message.success('操作成功')
                  this.$emit('callGetTableData')
                  this.$emit('callGetDetail')
                }
              })
            }else{
              changeTime(this.changeTimeFormData).then(res => {
                if (res.code === 200) {
                  this.$dialog.toast('操作成功')
                  this.changeTimeDialogVisible = false
                  this.changeTimeFormData = {}
                  this.$emit('callGetTableData')
                  this.$emit('callGetDetail')
                } else {
                  this.$message.warning(res.msg)
                }
              })
            }
          })
        }
      })
    },
    // 取消预约
    handleCancel() {
      if (this.detailData.status === 0 || this.detailData.status === 1) {
        this.cancelDialogVisible = true
      } else {
        this.$message.warning('只有预约未开始时才可取消')
      }
    },
    // 取消预约-dialog-关闭事件
    closeCancelDialog() {
      this.cancelDialogVisible = false
      this.cancelFormData = {}
    },
    formatCost() {
      // 分钟单价
      const each = Number((Number(this.detailData.consultAmount) / Number(this.detailData.consultDuration)).toFixed(2))
      // 当前时间
      const now = moment()
      // 预约时间
      const appointment = moment(this.detailData.appointmentTime)
      // 计算时间差（分钟）
      const minutesDiff = appointment.diff(now, 'minutes')
      if (minutesDiff <= 30) {
        // 半小时内
        return {
          minutesDiff: '半小时内',
          amount: 5,
          price: 5 * each
        }
      } else if (minutesDiff <= 120) {
        // 2小时内
        return {
          minutesDiff: '2小时内',
          amount: 3,
          price: 3 * each
        }
      } else if (minutesDiff <= 480) {
        // 8小时内
        return {
          minutesDiff: '8小时内',
          amount: 2,
          price: 2 * each
        }
      } else if (minutesDiff <= 1440) {
        // 24小时内
        return {
          minutesDiff: '24小时内',
          amount: 1,
          price: 1 * each
        }
      } else {
        // 超过24小时
        return {
          amount: 0
        }
      }
    },
    // 取消预约-dialog-确认取消
    handleConfirmCancel() {
      if(this.$store.state.UserInfo.isManage === true && !this.cancelFormData.initiatorType) {
        this.$message.warning('请选择发起方')
        return
      }
      this.cancelFormData.appointmentId = this.detailData.appointmentId
      const {minutesDiff, amount, price} = this.formatCost()
      if (this.detailData.status === 0 || amount === 0) {
        this.$confirm('确认取消吗').then(()=>{
          consultMeetingCancel(this.cancelFormData).then(res => {
            if (res.code === 200) {
              this.$dialog.toast('操作成功')
              this.cancelDialogVisible = false
              this.cancelFormData = {}
              this.$emit('callGetDetail')
            } else {
              this.$message.warning(res.msg)
            }
          })
        })
      } else {
        let text = ''
        if(this.$store.state.UserInfo.isManage === true) {
          if(this.cancelFormData.initiatorType === 1) {
            // 承约人
            text = `${minutesDiff}取消，需生成一笔${amount}分钟量（${price}元）的负收入到您账户。确认取消吗？`
          }
          if(this.cancelFormData.initiatorType === 2) {
            // 预约人
            text = `${minutesDiff}取消，需扣除${amount}分钟量（${price}元）的费用。确认取消吗？`
          }
        }else{
          if (this.detailData.authType === 1) {
            // 承约人
            text = `${minutesDiff}取消，需生成一笔${amount}分钟量（${price}元）的负收入到您账户。确认取消吗？`
          }
          if (this.detailData.authType === 2) {
            // 预约人
            text = `${minutesDiff}取消，需扣除${amount}分钟量（${price}元）的费用。确认取消吗？`
          }
        }
        this.$confirm(text).then(() => {
          consultMeetingCancel(this.cancelFormData).then(res => {
            if (res.code === 200) {
              this.$dialog.toast('操作成功')
              this.cancelDialogVisible = false
              this.cancelFormData = {}
              this.$emit('callGetDetail')
            } else {
              this.$message.warning(res.msg)
            }
          })
        })
      }
    },
    // 退款
    handleRefund() {
      this.$router.push({
        path: '/orderList',
        query: {
          appointmentId: this.detailData.appointmentId
        }
      })
    },
    // 回看
    handleVideoRecords() {
      videoRecords(this.detailData.appointmentId).then(res => {
        if (res.code === 200) {
          this.recordData = res.data
          this.recordDialogVisible = true
        }
      })
    },
    // 回看录像-dialog-关闭事件
    closeRecordDialog() {
      this.recordDialogVisible = false
    },
    // 回看录像-dialog-打开录像文件
    handleOpenRecordVideo(videoInfo) {
      const routeData = this.$router.resolve({
        path: '/videoPlay',
        query: {
          appId: videoInfo.appId,
          psign: videoInfo.psign,
          cloudFileId: videoInfo.cloudFileId,
          fileName: videoInfo.fileName
        }
      })
      window.open(routeData.href, '_blank')
    },
    // 关闭
    handleClose() {
      this.closeDialogVisible = true
    },
    // 关闭咨询室-dialog-关闭事件
    closeRoomDialog() {
      this.closeDialogVisible = false
      this.closeFormData = {}
    },
    // 关闭咨询室-dialog-确认关闭咨询室
    handleConfirmClose() {
      this.closeFormData.appointmentId = this.detailData.appointmentId
      this.$refs.refCloseForm.validate(valid => {
        if (valid) {
          consultMeetingClose(this.closeFormData).then(res => {
            if(res.code === 200) {
              this.closeRoomDialog()
            }else{
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    handleOpenHistoryDialog() {
      queryBehaviorRecords(this.detailData.appointmentId).then(res => {
        if (res.code === 200) {
          this.historyDialogTableData = res.data
          this.historyDialogVisible = true
        }
      })
    },
    // 行为记录-dialog-关闭事件
    closeHistoryDialog() {
      this.historyDialogVisible = false
      this.historyDialogTableData = []
    }
  }
}
</script>
<style lang="scss">
.consulting-detail {
  background-color: #ffffff;
  border-radius: 8px;
  margin-top: 32px;
  padding: 24px 32px;
  font-family: PingFang HK, PingFang HK;
  .detail-header {
    display: flex;
    align-content: center;
    margin-bottom: 40px;
    .header-title {
      flex: 1;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 20px;
      color: #333333;
    }
  }
  .header-button {
    .el-button {
      min-width: 104px;
    }
  }
  .el-button {
    border-radius: 60px;
    font-size: 18px;
  }
  .detail-container {
    .el-form-item__label {
      font-weight: 400;
      font-size: 18px;
      color: #999999;
    }
    .el-form-item__content {
      font-weight: 600;
      font-size: 18px;
      color: #000000;
    }
    .user-info-container {
      display: flex;
      .user-avatar {
        position: relative;
        .user-gender {
          border-radius: 50%;
          position: absolute;
          right: 0px;
          top: 5px;
          width: 24px;
          height: 24px;
        }
        .gender-0 {
          background-color: #ff57f7;
        }
        .gender-1 {
          background-color: #57c7ff;
        }
        .follow-btn {
          display: flex;
          align-items: center;
          gap: 2px;
          position: absolute;
          top: 88px;
          width: 88px;
          height: 35px;
          left: 9px;
          padding: 0px;
          justify-content: center;
        }
      }
      .user-info {
        margin-left: 16px;
        .name-row {
          display: flex;
          .nick-name {
            font-weight: 600;
            font-size: 20px;
            color: #333333;
            padding-top: 2px;
          }
          .user-tag {
            display: flex;
            gap: 14px;
            margin-left: 19px;
            margin-right: 25px;
            .user-tag-item {
              background: rgba(255, 114, 76, 0.16);
              border-radius: 4px;
              font-weight: 400;
              font-size: 20px;
              color: #ff724c;
              padding: 2px 16px;
            }
          }
          .work-info {
            font-weight: 600;
            font-size: 20px;
            color: #333333;
            padding-top: 2px;
          }
        }
        .position-row {
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          margin-bottom: 5px;
        }
        .btn-row {
          display: flex;
          gap: 24px;
          .el-button {
            height: 35px;
            padding: 5px 16px;
          }
        }
      }
    }
    .consulting-container {
      display: flex;
      justify-content: space-between;
      gap: 122px;
      .container-left {
        flex: 1;
      }
      .container-right {
        .el-form-item__content {
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .more-row {
      text-align: right;
      .el-image {
        width: 32px;
        height: 32px;
        cursor: pointer;
      }
    }
  }
}
.more-btn {
  font-family: PingFang HK, PingFang HK;
  font-weight: 400;
  font-size: 22px;
  .el-image {
    width: 32px;
    height: 32px;
    vertical-align: sub;
    margin-right: 8px;
  }
  .report {
    color: #eb5757;
  }
}
.record-video {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  .record-video-btn {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    background-color: #1fd6be;
    color: #ffffff;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.popper-width{
  width: 500px;
}
.history-dialog{
  border-radius: 8px;
}
</style>
